export default __webpack_public_path__ + "static/media/powered-by-goopter-white.86b5aae1.svg";